import { Button } from "@clockwise/design-system";
import { InfoFilled } from "@clockwise/icons";
import { getFormattedDateRange } from "@clockwise/web-commons/src/util/date.util";
import { Dialog } from "@material-ui/core";
import { DateTime } from "luxon";
import React from "react";
import { Divider } from "../web-app-calendar/calendar-popover/atoms/Divider";

export const RescheduleConfirmationModal = ({
  externalEventId,
  title,
  onClose,
  duration,
  proposedStart,
  existingStart,
  onSave,
  isOpen,
}: {
  externalEventId: string;
  proposedStart: string;
  existingStart: string;
  title: string;
  onClose: () => void;
  duration: number;
  onSave: (externalEventId: string, start: string) => void;
  isOpen: boolean;
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{ className: "cw-w-[400px] cw-rounded-xl" }}
      BackdropProps={{
        classes: { root: "cw-bg-[#000000] cw-bg-opacity-30" },
      }}
    >
      <div className="cw-flex-col cw-body-sm">
        <div className="cw-py-2 cw-px-4 cw-border-b cw-border-solid cw-border-muted cw-font-semibold cw-text-default">
          Move this Event
        </div>
        <div className="cw-flex-col cw-py-2 cw-px-4">
          <div className="cw-my-2">What would you like to do with the changes made to:</div>
          <div className="cw-font-bold cw-py-1"> {title}</div>
          <ProposedTime start={proposedStart} duration={duration} />
          <OriginalTime start={existingStart} duration={duration} />
        </div>

        <div className="cw-flex-col cw-py-2 cw-px-4">
          <Divider />
          <div className="cw-py-2 cw-text-12 cw-text-subtle cw-flex cw-items-center">
            <InfoFilled className="cw-w-3 cw-h-3 cw-mr-1" />
            Changes will only affect this specific instance
          </div>
        </div>
        <div className="cw-flex cw-justify-between cw-border-t cw-border-solid cw-border-muted cw-py-2 cw-px-3">
          <Button variant="outlined" sentiment="neutral" size="mini" onClick={onClose}>
            Discard
          </Button>
          <Button
            sentiment="positive"
            size="mini"
            onClick={() => onSave(externalEventId, proposedStart)}
          >
            Save & send
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

const ProposedTime = ({ start, duration }: { start: string; duration: number }) => {
  const endTime = DateTime.fromISO(start).plus({ minutes: duration }).toISO();
  const dateString = getFormattedDateRange({ start, end: endTime });
  return (
    <div className="cw-flex cw-body-sm">
      <div className="cw-w-[240px]"> {dateString} </div>
      <div className="cw-text-12 cw-text-subtle-disabled cw-pl-2"> New </div>
    </div>
  );
};

const OriginalTime = ({ start, duration }: { start: string; duration: number }) => {
  const endTime = DateTime.fromISO(start).plus({ minutes: duration }).toISO();
  const dateString = getFormattedDateRange({ start, end: endTime });
  return (
    <div className="cw-flex cw-body-sm">
      <div className="cw-w-[240px] cw-text-subtle cw-line-through"> {dateString} </div>
      <div className="cw-text-12 cw-text-subtle-disabled cw-pl-2"> Original</div>
    </div>
  );
};
